
import { combineReducers } from 'redux';

export default combineReducers({
    dummy: (state = {}, action) => state
});
